export default __webpack_public_path__ + "static/media/avatar02.129a3d04.jpg";